import React from 'react';
import OnboardingDashboard from './page/OnboardingDashboard';
import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';

/**
 * Onboarding Module - Three-Phase Flow
 * 
 * Phase 1: Manager Initiation
 * - Manager creates new/rehire/existing employee onboarding
 * - Enters basic employee information
 * - Assigns security role and hierarchy
 * - Creates Mabel user and sends welcome email
 * 
 * Phase 2: Employee Data Entry
 * - Employee confirms/edits basic info
 * - Completes address and personal details
 * - Sets availability (if scheduling licensed)
 * - Reviews policies and completes PDFs
 * 
 * Phase 3: Manager Review
 * - Manager reviews completed documentation
 * - Attests to having reviewed cloud-stored documents
 * - Completes onboarding
 * - Optionally integrates with POS
 */
export function Onboarding() {
	const { workplaceId } = useWorkplacesContext();

	// TODO: Get organization ID from auth context or workplace
	const organizationId = '';

	return (
		<OnboardingDashboard
			workplaceId={workplaceId?.toString() || ''}
			organizationId={organizationId}
		/>
	);
}
